<template>
    <div class="container mx-auto min-h-screen">
        <div class="flex flex-col items-center justify-center mt-24">
            <img class="w-56" src="../assets/logo-megaluzz.png" alt="Megaluzz Logo">
        </div>

        <div class="flex flex-col items-center gap-y-4 mt-8 px-4">
            <div v-if="loading" class="text-gray-500 text-center">Validando certificado...</div>

            <template v-else-if="result && result.valid">
                <div class="flex items-center gap-x-2 text-green-700">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    <h1 class="font-bold text-xl sm:text-2xl text-center">Certificado válido</h1>
                </div>

                <div class="w-full max-w-lg rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
                    <dl class="grid grid-cols-1 gap-y-3">
                        <div>
                            <dt class="text-xs font-semibold uppercase text-gray-400">Participante</dt>
                            <dd class="text-base text-gray-800">{{ result.participant_name || '--' }}</dd>
                        </div>
                        <div>
                            <dt class="text-xs font-semibold uppercase text-gray-400">Treinamento</dt>
                            <dd class="text-base text-gray-800">{{ result.event_theme || '--' }}</dd>
                        </div>
                        <div v-if="result.training_type">
                            <dt class="text-xs font-semibold uppercase text-gray-400">Tipo</dt>
                            <dd class="text-base text-gray-800">{{ result.training_type }}</dd>
                        </div>
                        <div v-if="result.instructor">
                            <dt class="text-xs font-semibold uppercase text-gray-400">Instrutor</dt>
                            <dd class="text-base text-gray-800">{{ result.instructor }}</dd>
                        </div>
                        <div v-if="result.event_date">
                            <dt class="text-xs font-semibold uppercase text-gray-400">Data</dt>
                            <dd class="text-base text-gray-800">{{ dateTime(result.event_date) }}</dd>
                        </div>
                        <div v-if="result.workload_hours">
                            <dt class="text-xs font-semibold uppercase text-gray-400">Carga horária</dt>
                            <dd class="text-base text-gray-800">{{ result.workload_hours }} hora(s)</dd>
                        </div>
                    </dl>
                </div>
            </template>

            <template v-else>
                <div class="flex items-center gap-x-2 text-red-600">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                    </svg>
                    <h1 class="font-bold text-xl sm:text-2xl text-center">Certificado não encontrado</h1>
                </div>
                <p class="text-gray-500 text-center max-w-xl">
                    O código informado não corresponde a um certificado emitido pela Megaluzz. Verifique o código e tente novamente.
                </p>
            </template>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { EventService } from '../services/Entity';
import { dateTime } from '../filters/date';

export default {
    name: 'CertificateValidation',
    setup() {
        const route = useRoute();
        const loading = ref(true);
        const result = ref(null);

        async function validate() {
            try {
                const { data } = await EventService.validateCertificate(route.params.code);
                result.value = data;
            } catch (err) {
                console.log(err);
                result.value = { valid: false };
            } finally {
                loading.value = false;
            }
        }

        validate();

        return { loading, result, dateTime };
    }
}
</script>
